// Mongolian translations
export const mn: Record<string, string> = {
  'menu.dashboard': 'Хяналтын самбар',
  'menu.customers': 'Үйлчлүүлэгчид',
  'menu.products': 'Бүтээгдэхүүн',
  'menu.users': 'Хэрэглэгчид',
  'menu.settings': 'Тохиргоо',
  'menu.logout': 'Гарах',
  'dashboard.title': 'Хяналтын самбар',
  'dashboard.newOrder': 'Шинэ захиалга',
  'order.title': 'Шинэ захиалга',
  'order.customer': 'Үйлчлүүлэгч',
  'order.products': 'Бүтээгдэхүүн',
  'order.total': 'Нийт',
  'users.title': 'Хэрэглэгчид',
  'users.name': 'Нэр',
  'users.email': 'Имэйл',
  'common.yes': 'Тийм',
  'common.no': 'Үгүй',
  'common.cancel': 'Цуцлах',
  'common.save': 'Хадгалах',
  'common.search': 'Хайх',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Нэвтрэх',
  'login.welcome': 'Тавтай морил, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Имэйл',
  'signup.phone': 'Утас',
  'menu.reportsAndAccounting': 'Тайлан ба нягтлан бодох',
  'menu.systemAndCommunication': 'Систем ба харилцаа',
};